import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAuthUser } from 'auth/hooks';
import { AccessPermissions } from 'core/enums';
import { PageLayout } from 'coreOld/components';
import { Home } from 'home/components';
import { isPlainHomepageInstance } from 'home/utils';
import { hasPermission } from 'router/utils';
import { supportRequestListPath } from 'support/routes/routePaths';

const HomePage = ({ logoHomePage = false }: { logoHomePage?: boolean }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { user, isLoading } = useAuthUser();

  const accessPlainHomepage = !user && isPlainHomepageInstance();

  useEffect(() => {
    if (logoHomePage) {
      return;
    }

    const hasSupportRequestHomepagePermission = hasPermission(
      [AccessPermissions.SUPPORT_REQUEST_HOMEPAGE, AccessPermissions.SUPPORT_REQUEST_LIST],
      user?.resources
    );

    if (user && hasSupportRequestHomepagePermission) {
      navigate(supportRequestListPath());
    }
  }, [user, logoHomePage, navigate]);

  return (
    <PageLayout
      title={t('labelHome')}
      hasHeader={!accessPlainHomepage}
      hasSubHeader={false}
      hasSearchBar={false}
    >
      <Home user={user} accessPlainHomepage={accessPlainHomepage} isPageLoading={isLoading} />
    </PageLayout>
  );
};

export default HomePage;
